Bingo.DemandsAgentCanContactTrigger = {};

Bingo.DemandsAgentCanContactTrigger.init = () => {
    $('.js-demandBlock__agentsCanContactCheckbox').on('click', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        $.nette.ajax({
            url: $(this).data('agents-can-contact-change-url'),
        }).success((data) => {
            if (data.success) {
                if (data.isEnabled) {
                    $(this).prop('checked', true);
                } else {
                    $(this).prop('checked', false);
                }
            }
        });

        return false;
    });
};
